var _style, _g, _defs, _g2, _g3, _defs2, _g4, _g5, _defs3, _g6, _defs4, _g7, _defs5, _g8, _g9, _defs6, _g10, _g11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFramePc01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "design",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1460 896",
    style: {
      enableBackground: "new 0 0 1460 896"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#030646;}\r\n\t.st1{clip-path:url(#SVGID_00000083790388570794126370000012481574423078769285_);}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{clip-path:url(#SVGID_00000160870194806203730430000013681023956489325247_);}\r\n\t.st4{clip-path:url(#SVGID_00000094615150170162846640000008460862732724821382_);}\r\n\t.st5{clip-path:url(#SVGID_00000049187084159460966230000009148538856139154328_);}\r\n\t.st6{clip-path:url(#SVGID_00000005235225991334964200000014203890100730669758_);}\r\n\t.st7{clip-path:url(#SVGID_00000112602264331689759910000008885901694895989402_);}\r\n\t.st8{fill:none;stroke:#FFFFFF;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_978"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8750",
    className: "st0",
    d: "M1383.4,522.8c4.9,42,4.8,84.5-0.4,126.5c-0.5,3.9-0.9,7.7-1.4,11.6 c-4.4,35.8-5.2,71.8-2.3,107.8c0,0.2,0,0.4,0.1,0.6c4.2,55.4-24.7,90.3-74.5,88.8c-16.8-0.5-33.7-1.2-50.5-2 c-61.5-2.8-123,3.2-182.8,17.8c-10.3,2.5-20.5,5-30.8,7.4c-63.3,15.1-127.7,18.1-191.1,8.7c-8.9-1.3-17.8-2.7-26.8-4.1 c-16.8-2.6-33.7-3.8-50.5-5.7c-14.4-1.5-28.9-2.1-43.4-2c-14.5-0.2-29,0.5-43.4,2c-16.8,1.9-33.7,3.1-50.5,5.7 c-8.9,1.4-17.8,2.7-26.8,4.1c-63.4,9.5-127.8,6.4-191.1-8.7c-10.3-2.4-20.5-4.9-30.8-7.4c-59.8-14.6-121.3-20.6-182.8-17.8 c-16.8,0.8-33.7,1.5-50.5,2c-49.8,1.5-78.7-33.4-74.5-88.8c0-0.2,0-0.4,0.1-0.6c2.9-35.9,2.1-72-2.3-107.8 c-0.5-3.9-0.9-7.7-1.4-11.6c-5.2-42-5.3-84.5-0.4-126.5V410.7c-4.9-42-4.8-84.5,0.4-126.5c0.5-3.9,0.9-7.7,1.4-11.6 c4.4-35.8,5.2-71.9,2.3-107.8c0-0.2,0-0.4-0.1-0.6c-4.2-55.4,24.7-90.3,74.5-88.8c16.8,0.5,33.7,1.2,50.5,2 c61.5,2.8,123-3.2,182.8-17.8c10.3-2.5,20.5-5,30.8-7.4c63.3-15.1,127.7-18.1,191.1-8.7c8.9,1.3,17.8,2.7,26.8,4.1 c16.8,2.6,33.6,4,50.5,5.7c20,2,55.1,3.3,86.7,0c16.8-1.8,33.7-3.1,50.5-5.7c8.9-1.4,17.8-2.7,26.8-4.1 c63.4-9.5,127.8-6.4,191.1,8.7c10.3,2.4,20.5,4.9,30.8,7.4c59.8,14.6,121.3,20.6,182.8,17.8c16.8-0.8,33.7-1.5,50.5-2 c49.8-1.5,78.7,33.4,74.5,88.8c0,0.2,0,0.4-0.1,0.6c-2.9,35.9-2.1,72,2.3,107.8c0.5,3.9,0.9,7.7,1.4,11.6 c5.2,42,5.3,84.5,0.4,126.5L1383.4,522.8L1383.4,522.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_954"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 1418.5,
    y: 371.1,
    width: 16,
    height: 16
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000067224090637702771350000011492542963849310870_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000067224090637702771350000011492542963849310870_)"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_953"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8720",
    className: "st2",
    d: "M1425.4,380.3c-5.3,0.7-6.9-0.2-6.9-1.1s1.5-1.9,6.9-1.1c-0.7-5.4,0.2-6.9,1.1-6.9 s1.9,1.5,1.1,6.9c5.3-0.7,6.9,0.2,6.9,1.1s-1.5,1.9-6.9,1.1c0.7,5.4-0.2,6.9-1.1,6.9S1424.6,385.6,1425.4,380.3"
  }))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_956"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_955"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8721",
    className: "st2",
    d: "M1407.5,365.1c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S1408.6,365.1,1407.5,365.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8722",
    className: "st2",
    d: "M1413.5,395.1c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S1414.6,395.1,1413.5,395.1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_958"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000114762373408724760120000012796413998803508872_",
    x: 25.9,
    y: 371.1,
    width: 16,
    height: 16
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000061461434197326151620000000731459056557116341_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000114762373408724760120000012796413998803508872_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000061461434197326151620000000731459056557116341_)"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_957"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8723",
    className: "st2",
    d: "M35,380.3c5.3,0.7,6.9-0.2,6.9-1.1s-1.5-1.9-6.9-1.1c0.7-5.4-0.2-6.9-1.1-6.9 s-1.9,1.5-1.1,6.9c-5.4-0.7-6.9,0.2-6.9,1.1s1.5,1.9,6.9,1.1c-0.7,5.4,0.2,6.9,1.1,6.9S35.8,385.6,35,380.3"
  }))))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_960"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_959"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8724",
    className: "st2",
    d: "M52.9,365.1c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S51.8,365.1,52.9,365.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8725",
    className: "st2",
    d: "M46.9,395.1c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S45.8,395.1,46.9,395.1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_962"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000066496822716890627470000015083710479525391753_",
    x: 0,
    y: 458.7,
    width: 16,
    height: 16
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139254741140899560030000008557810229051031207_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000066496822716890627470000015083710479525391753_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139254741140899560030000008557810229051031207_)"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_961"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8726",
    className: "st2",
    d: "M9.1,467.9c5.3,0.7,6.9-0.2,6.9-1.1s-1.5-1.9-6.9-1.1c0.7-5.4-0.2-6.9-1.1-6.9 s-1.9,1.5-1.1,6.9C1.6,465,0,465.9,0,466.8s1.5,1.9,6.9,1.1c-0.7,5.4,0.2,6.9,1.1,6.9S9.9,473.2,9.1,467.9"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_964"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000155835058627355993200000015390938292840276107_",
    x: 1444,
    y: 458.7,
    width: 16,
    height: 16
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000041998003695743461500000010481574567842346152_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155835058627355993200000015390938292840276107_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000041998003695743461500000010481574567842346152_)"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_963"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8727",
    className: "st2",
    d: "M1450.9,467.9c-5.3,0.7-6.9-0.2-6.9-1.1s1.5-1.9,6.9-1.1c-0.7-5.4,0.2-6.9,1.1-6.9 s1.9,1.5,1.1,6.9c5.3-0.7,6.9,0.2,6.9,1.1s-1.5,1.9-6.9,1.1c0.7,5.4-0.2,6.9-1.1,6.9S1450.1,473.2,1450.9,467.9"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_966"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000111182724368566395850000011805378367170050957_",
    x: 1418.5,
    y: 546.5,
    width: 16,
    height: 16
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000173162126611230572680000002370540641353378728_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000111182724368566395850000011805378367170050957_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000173162126611230572680000002370540641353378728_)"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_965"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8728",
    className: "st2",
    d: "M1425.4,553.2c-5.3-0.7-6.9,0.2-6.9,1.1s1.5,1.9,6.9,1.1c-0.7,5.3,0.2,6.9,1.1,6.9 s1.9-1.5,1.1-6.9c5.3,0.7,6.9-0.2,6.9-1.1s-1.5-1.9-6.9-1.1c0.7-5.3-0.2-6.9-1.1-6.9S1424.6,548,1425.4,553.2"
  }))))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_968"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_967"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8729",
    className: "st2",
    d: "M1407.5,568.5c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S1408.6,568.5,1407.5,568.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8730",
    className: "st2",
    d: "M1413.5,538.5c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S1414.6,538.5,1413.5,538.5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_970"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000165921442233267230030000017399871662036847536_",
    x: 25.9,
    y: 546.5,
    width: 16,
    height: 16
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000064312955461444155080000008485732120153463682_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000165921442233267230030000017399871662036847536_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000064312955461444155080000008485732120153463682_)"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_969"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8731",
    className: "st2",
    d: "M35,553.2c5.3-0.7,6.9,0.2,6.9,1.1s-1.5,1.9-6.9,1.1c0.7,5.3-0.2,6.9-1.1,6.9 s-1.9-1.5-1.1-6.9c-5.4,0.7-6.9-0.2-6.9-1.1s1.5-1.9,6.9-1.1c-0.7-5.3,0.2-6.9,1.1-6.9S35.8,548,35,553.2"
  }))))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_971"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8732",
    className: "st2",
    d: "M52.9,568.5c1.1,0,2-0.9,2-2s-0.9-2-2-2s-2,0.9-2,2S51.8,568.5,52.9,568.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8733",
    className: "st2",
    d: "M46.9,538.5c1.1,0,2-0.9,2-2s-0.9-2-2-2s-2,0.9-2,2S45.8,538.5,46.9,538.5"
  }), /*#__PURE__*/React.createElement("line", {
    id: "__4",
    className: "st8",
    x1: 721.9,
    y1: 46.2,
    x2: 721.9,
    y2: 74.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8734",
    className: "st8",
    d: "M714.5,45.7v7.1c0,6-2.9,12.5-10.4,13.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8735",
    className: "st8",
    d: "M745.9,45.7v7.1c0,6,2.9,12.5,10.4,13.1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "__5",
    className: "st8",
    x1: 738.5,
    y1: 46.2,
    x2: 738.5,
    y2: 74.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "__6",
    className: "st8",
    x1: 730.2,
    y1: 46.7,
    x2: 730.2,
    y2: 71.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8736",
    className: "st8",
    d: "M717.4,29.4l4.1-3.1l-4.1-3.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8737",
    className: "st8",
    d: "M743,29.4l-4.1-3.1l4.1-3.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8738",
    className: "st8",
    d: "M733.5,28.2l-3.3,5.2l-3.3-5.2H733.5L733.5,28.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8739",
    className: "st8",
    d: "M730.2,46.7c1.7,0,5.3-0.3,6.8-1.3c2.8,1.2,9.8,1.2,13.6-2c5.8,0.9,8.8-1.6,10.5-3.3 c-2.3-3.1-3.9-5.6-4-14.1c-0.1-12.3-9.2-25.5-26.8-25.5S703.6,13.7,703.4,26c-0.1,8.5-1.7,10.9-4,14.1c1.6,1.8,4.7,4.3,10.5,3.3 c3.8,3.3,10.8,3.3,13.6,2C725,46.4,728.6,46.7,730.2,46.7L730.2,46.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "_\\u5186\\u5F62_49",
    className: "st8",
    cx: 782.6,
    cy: 14.9,
    r: 9.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "_\\u5186\\u5F62_50",
    className: "st8",
    cx: 775.4,
    cy: 33.9,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "_\\u5186\\u5F62_51",
    className: "st8",
    cx: 678.2,
    cy: 19.9,
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8740",
    className: "st8",
    d: "M1129.4,90.4c49.4,6.5,87.1,6.7,132.8,4.6c12.7-0.6,30.3-2,43-2.3 c37.6-1.2,59.3,25.2,56.2,66.9c0,0.1,0,0.3,0,0.4c-2.2,26.7-3.6,54-0.7,81.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8741",
    className: "st8",
    d: "M328.5,90.4c-49.4,6.5-87.1,6.7-132.8,4.6c-12.7-0.6-30.4-2-43-2.3 c-37.6-1.2-59.3,25.2-56.2,66.9c0,0.1,0,0.3,0,0.4c2.2,26.7,3.6,54,0.7,81.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8742",
    className: "st8",
    d: "M328.5,90.4c-49.4,6.5-87.1,6.7-132.8,4.6c-12.7-0.6-30.4-2-43-2.3 c-37.6-1.2-59.3,25.2-56.2,66.9c0,0.1,0,0.3,0,0.4c2.2,26.7,3.6,54,0.7,81.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8743",
    className: "st8",
    d: "M685.6,53.3c-16.8-1.9-33.7-3.1-50.5-5.7c-8.9-1.4-17.8-2.7-26.8-4.1 c-63.4-9.5-127.8-6.4-191.1,8.7c-10.3,2.4-20.5,4.9-30.8,7.4c-59.8,14.6-121.3,20.6-182.8,17.8c-16.8-0.8-33.7-1.5-50.5-2 c-49.8-1.5-78.7,33.4-74.5,88.8c0,0.2,0,0.4,0.1,0.6c2.9,35.9,2.1,72-2.3,107.8c-0.5,3.9-0.9,7.7-1.4,11.6 c-5.2,42-5.3,84.5-0.4,126.5c0.5,3.9,0.5,7.9,0,11.8c-3.6,32-42.1,39.6-54.2,17.8c-9.7-17.5,12-33.9,24.5-17.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8744",
    className: "st8",
    d: "M1413.1,422.7c12.4-16.4,34.1,0,24.5,17.5c-12.1,21.9-50.6,14.2-54.2-17.8 c-0.4-3.9-0.4-7.9,0-11.8c4.9-42,4.8-84.5-0.4-126.5c-0.5-3.9-0.9-7.7-1.4-11.6c-4.4-35.8-5.2-71.9-2.3-107.8c0-0.2,0-0.4,0.1-0.6 c4.2-55.4-24.7-90.3-74.5-88.8c-16.8,0.5-33.7,1.2-50.5,2c-61.5,2.8-123-3.2-182.8-17.8c-10.3-2.5-20.5-5-30.8-7.4 C977.5,37,913.1,34,849.7,43.4c-8.9,1.3-17.8,2.7-26.8,4.1c-16.8,2.6-33.7,3.8-50.5,5.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8745",
    className: "st8",
    d: "M1129.4,90.4c49.4,6.5,87.1,6.7,132.8,4.6c12.7-0.6,30.3-2,43-2.3 c37.6-1.2,59.3,25.2,56.2,66.9c0,0.1,0,0.3,0,0.4c-2.2,26.7-3.6,54-0.7,81.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8746",
    className: "st8",
    d: "M328.5,843.1c-49.4-6.5-87.1-6.7-132.8-4.6c-12.7,0.6-30.4,2-43,2.3 c-37.6,1.2-59.4-25.1-56.2-66.8c0-0.2,0-0.3,0-0.5c2.2-26.7,3.6-54,0.7-81.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8747",
    className: "st8",
    d: "M328.5,843.1c-49.4-6.5-87.1-6.7-132.8-4.6c-12.7,0.6-30.4,2-43,2.3 c-37.6,1.2-59.4-25.1-56.2-66.8c0-0.2,0-0.3,0-0.5c2.2-26.7,3.6-54,0.7-81.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8748",
    className: "st8",
    d: "M1413.1,510.8c12.4,16.4,34.1,0,24.5-17.5c-12.1-21.9-50.6-14.2-54.2,17.8 c-0.4,3.9-0.4,7.9,0,11.8c4.9,42,4.8,84.5-0.4,126.5c-0.5,3.9-0.9,7.7-1.4,11.6c-4.4,35.8-5.2,71.8-2.3,107.8c0,0.2,0,0.4,0.1,0.6 c4.2,55.4-24.7,90.3-74.5,88.8c-16.8-0.5-33.7-1.2-50.5-2c-61.5-2.8-123,3.2-182.8,17.8c-10.3,2.5-20.5,5-30.8,7.4 c-63.3,15.1-127.7,18.1-191.1,8.7c-8.9-1.3-17.8-2.7-26.8-4.1c-16.8-2.6-33.7-3.8-50.5-5.7c-14.4-1.5-28.9-2.1-43.4-2 c-14.5-0.2-29,0.5-43.4,2c-16.8,1.9-33.7,3.1-50.5,5.7c-8.9,1.4-17.8,2.7-26.8,4.1c-63.4,9.5-127.8,6.4-191.1-8.7 c-10.3-2.4-20.5-4.9-30.8-7.4c-59.8-14.6-121.3-20.6-182.8-17.8c-16.8,0.8-33.7,1.5-50.5,2c-49.8,1.5-78.7-33.4-74.5-88.8 c0-0.2,0-0.4,0.1-0.6c2.9-35.9,2.1-72-2.3-107.8c-0.5-3.9-0.9-7.7-1.4-11.6c-5.2-42-5.3-84.5-0.4-126.5c0.5-3.9,0.5-7.9,0-11.8 c-3.6-32-42.1-39.6-54.2-17.8c-9.7,17.5,12,33.9,24.5,17.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8749",
    className: "st8",
    d: "M1129.4,843.1c49.4-6.5,87.1-6.7,132.8-4.6c12.7,0.6,30.3,2,43,2.3 c37.6,1.2,59.3-25.2,56.2-66.9c0-0.2,0-0.3,0-0.5c-2.2-26.7-3.6-54-0.7-81.2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFramePc01);
export default __webpack_public_path__ + "static/media/frame_pc_01.549405c9e2c2a0f49bb91d87a95cfbe3.svg";
export { ForwardRef as ReactComponent };